module.exports = __webpack_public_path__ + "img/decouverte.e7b19bdd.svg";